import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { useMe } from '../../../hooks/useMe';
import { useAuth } from '../../../AuthProvider';
import { User } from 'react-feather';
import { Suspense } from 'react';
import { formatJapaneseDateTimeString } from '../../../utils/dateUtils';

export const AccountButton = () => {
  const { signOut } = useAuth();
  return (
    <Popover className="relative">
      <PopoverButton className="h-9 p-2 flex items-center gap-2 rounded border-2 border-white text-white">
        <User size={20} />
        <div className="text-base">アカウント</div>
      </PopoverButton>
      <PopoverPanel className="absolute flex flex-col items-start gap-2 mt-2 right-0 w-48 rounded border-2 border-darkblue_70 bg-white text-darkblue_100">
        <div className="w-full border-b border-darkblue_40 p-2">
          <Suspense
            fallback={<div className="text-darkblue_50 text-sm">ユーザー情報取得中...</div>}
          >
            <UserInfo />
          </Suspense>
        </div>
        <div className="px-2 pt-1 pb-2">
          <button onClick={signOut} className="hover:underline">
            ログアウト
          </button>
        </div>
      </PopoverPanel>
    </Popover>
  );
};

const UserInfo = () => {
  const me = useMe();
  const lastAuthenticatedAt =
    me?.lastAuthenticatedAt && !Number.isNaN(Date.parse(me.lastAuthenticatedAt))
      ? new Date(me.lastAuthenticatedAt)
      : undefined;
  return (
    <div>
      <div className="text-sm">{me?.teamName}</div>
      <div className="font-bold text-lg">{me?.memberName}</div>
      <div className="text-xs text-darkblue_60 mt-1">
        <div>最終ログイン:</div>
        <div className="mt-0.5">
          {lastAuthenticatedAt
            ? formatJapaneseDateTimeString(lastAuthenticatedAt, 'second')
            : '----'}
        </div>
      </div>
    </div>
  );
};
